import { ReactNode } from 'react';
import { BraxIcon } from 'design-system';

import externalLinks from '../variables/external-links';
import { Language } from '../utils/i18n/IntlContext';
import ExternalLink from '../components/ExternalLink';

export const YEAR = new Date().getFullYear();

const pt: Language = {
    // DS
    'Entrar com %s': (provider: string) => `Entrar com ${provider}`,
    // 'Arquivo %s': (format: string) => `Arquivo ${format}`,
    // 'Expirado a %n horas': (hours: number) => `Expirado a ${hours} ${hours > 1 ? 'horas' : 'hora'}`,
    // 'Restam %n horas e %n minutos': (hours: number, minutes: number) =>
    //     `Restam ${hours} ${hours > 1 ? 'horas' : 'hora'} e ${minutes} ${minutes > 1 ? 'minutos' : 'minuto'}`,
    // 'Último salvamento: %d': (date: string) => `Último salvamento: ${date}`,

    // ProjectProvider
    'Para editar esse marcador acesse o menu "%s"': (menu: ReactNode) => <><span>Para editar esse marcador acesse o menu "</span>{ menu }<span>"</span></>,

    // Notices
    'Caso já tenha efetuado o pagamento, envie-nos o comprovante no e-mail <link>contato@imersiovr.com</link> ou no Whatsapp <link>(47) 99102-0874</link>.': (<>
        Caso já tenha efetuado o pagamento, envie-nos o comprovante no e-mail <ExternalLink href="mailto:contato@imersiovr.com">contato@imersiovr.com</ExternalLink> ou no Whatsapp <ExternalLink href="https://wa.me/5547991020874">(47) 99102-0874</ExternalLink>.
    </>),

    // OAuthCallback
    'Conectado a sua conta %s': (email: string) => `Conectado a sua conta ${email}`,

    // Sign
    'Li e aceito os <link>termos de uso</link> e <link>política de privacidade</link>.': (<>
        Li e aceito os <ExternalLink href={externalLinks.termsOfUse}>termos de uso</ExternalLink> e <ExternalLink href={externalLinks.privacyPolicy}>política de privacidade</ExternalLink>.
    </>),

    // Courses
    '%n Horas - %n Aulas': (hours: number, lessons: number) => `${hours} Horas - ${lessons} Aulas`,

    // HelpSupport
    'E-mail: <link>contato@imersiovr.com</link>.': (<>
        E-mail: <ExternalLink href="mailto:contato@imersiovr.com">contato@imersiovr.com</ExternalLink>.
    </>),
    'Whatsapp: <link>(47) 99102-0874</link>.': (<>
        Whatsapp: <ExternalLink href="https://wa.me/5547991020874">(47) 99102-0874</ExternalLink>.
    </>),

    // HelpTutorials
    '%n minutos': (minutes: number) => `${minutes} minutos`,

    // CheckoutCoupons
    'n% desconto:': (descont: number) => `${descont}% desconto:`,

    // CheckoutStepThreeFields
    // 'Li e aceito os <link>termos de uso</link> e <link>política de privacidade</link>.': '',

    // CheckoutStepTwoFields
    // 'Nesta condição de pagamento você está deixando de economizar %n ao mês e %n ao ano.':
    //     (monthly: number, yearly: number) => `Nesta condição de pagamento você está deixando de economizar ${monthly} ao mês e ${yearly} ao ano.`,
    // 'Nesta condição de pagamento você está economizando %n ao mês e %n ao ano.':
    //     (monthly: number, yearly: number) => `Nesta condição de pagamento você está economizando ${monthly} ao mês e ${yearly} ao ano.`,

    // Plans
    'Total de %n tours virtuais': (amount: number) => `Total de ${amount} tours virtuais`,
    '%n imagens 360 por tour': (amount: number) => `${amount} imagens 360 por tour`,
    '%n projetos GSV por mês': (amount: number) => `${amount} projetos GSV por mês`,
    '%n logos': (amount: number) => `${amount} logos`,
    'equivalente a R$ %s / ano': (price: string) => `equivalente a R$ ${price}/ano`,
    'à vista ou até 12x R$ %s': (price: string) => `à vista ou até 12x de R$ ${price}`,
    '© Todos os direitos reservados - {year}': `© Todos os direitos reservados - ${YEAR}`,

    // ProjectMarkers
    'Agora você pode criar borrões diretamente na imagem. Para acessar, basta ir em Ambientes 360 e acessar a opção "Borrar Imagem" no ambiente desejado.': (<>
        <span>Agora você pode criar borrões diretamente na imagem. Para acessar, basta ir em </span>

        <strong>Ambientes 360</strong>

        <span> e acessar a opção "Borrar Imagem" no ambiente desejado.</span>
    </>),

    // ProjectRecording
    '3. Tempo (%ns)': (time: number) => `3. Tempo (${time}s)`,

    // RecordingCards
    'Para gerar um vídeo, acesse o menu "Projetos", clique no botão <icon>three-dots</icon> do projeto desejado e clique em "Gerar vídeo". Depois, siga o passo a passo de geração.': (<>
        <span>Para gerar um vídeo, acesse o menu "Projetos", clique no botão </span>
        <BraxIcon icon="three-dots" />
        <span> do projeto desejado e clique em "Gerar vídeo". Depois, siga o passo a passo de geração.</span>
    </>),

    // LinkTab
    'Arraste e solte aqui um ambiente para conectar com %s': (title: string) => (<>
        <span>Arraste e solte aqui um ambiente para conectar com </span>

        <strong>{ title }</strong>
    </>),

    // LocationTab
    'PlaceID: %s': (place: string) => `PlaceID: ${place}`,

    // StreetViewCard
    'Para criar um projeto do Google Street View, acesse o menu "Projetos", clique no botão <icon>three-dots</icon> do projeto desejado e clique em "Gerar Google Street View". Depois, siga o passo a passo de criação.': () => (<>
        <span>Para criar um projeto do Google Street View, acesse o menu "Projetos", clique no botão </span>
        <BraxIcon icon="three-dots" />
        <span> do projeto desejado e clique em "Gerar Google Street View". Depois, siga o passo a passo de criação.</span>
    </>),

    // Profile
    // 'Você fez alterações em %n formulário(s)': (amount: number) => `Você fez alterações em ${amount} formulário(s)`,

    // UserPaymentHistory
    '%n dias': (amount: number) => `${amount} dias`,

    // UserPlan
    'Plano %s': (plan: string) => `Plano ${plan}`,
    'Aceite em %d': (date: string) => (<>
        <span>Aceite em </span>

        <span>{ date }</span>
    </>),
    'Última atualização em %d': (date: string) => (<>
        <span>Última atualização em </span>

        <span>{ date }</span>
    </>),
    'true': 'Sim',
    'false': 'Não',
    '999999999': 'Ilimitado'
};

export default pt;
